import { createGlobalStyle } from 'styled-components';

import SharpGroteskBook20Woff2 from 'assets/fonts/SharpGroteskBook20.woff2';
import SharpGroteskBook20Woff from 'assets/fonts/SharpGroteskBook20.woff';
import SharpGroteskMedium20Woff2 from 'assets/fonts/SharpGroteskMedium20.woff2';
import SharpGroteskMedium20Woff from 'assets/fonts/SharpGroteskMedium20.woff';
import SharpGroteskSmBold20Woff2 from 'assets/fonts/SharpGroteskSmBold20.woff2';
import SharpGroteskSmBold20Woff from 'assets/fonts/SharpGroteskSmBold20.woff';
// import SharpGroteskSmBold25Woff2 from 'assets/fonts/SharpGroteskSmBold25.woff2';
// import SharpGroteskSmBold25Woff from 'assets/fonts/SharpGroteskSmBold25.woff';
import {
  orange,
  dark,
  primaryBlue,
  purple,
  purpleLighten20,
  purpleLighten80,
} from 'utils/color-styles';

/* eslint no-unused-expressions: 0 */
export default createGlobalStyle`
  html {
    background-color: #F7F7F7;
    height: 100%;
    color: ${dark};
  }

  body,
  #app,
  #app > div {
    height: 100%;
  }

  @font-face {
    font-family: 'Graphik';
    src: url(${SharpGroteskBook20Woff2}) format('woff2'),
      url(${SharpGroteskBook20Woff}) format('woff');
    font-weight: 300;
    font-style: normal;
  }

  @font-face {
    font-family: 'Graphik';
    src: url(${SharpGroteskBook20Woff2}) format('woff2'),
      url(${SharpGroteskBook20Woff}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Graphik';
    src: url(${SharpGroteskMedium20Woff2}) format('woff2'),
      url(${SharpGroteskMedium20Woff}) format('woff');
    font-weight: 500;
    font-style: normal;
  }

  @font-face {
    font-family: 'Graphik';
    src: url(${SharpGroteskSmBold20Woff2}) format('woff2'),
      url(${SharpGroteskSmBold20Woff}) format('woff');
    font-weight: 600;
    font-style: normal;
  }

  body {
    font-family: 'Graphik', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Helvetica Neue', Arial, sans-serif;
  }

  a {
    color: ${primaryBlue};
    text-decoration: none;
    cursor: pointer;

    &.hoverable {
      :hover {
        text-decoration: underline;
      }
    }
  }

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
  }

  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px white inset !important;
  }

  table.colored {
    border-radius: 3px;
    overflow: hidden;

    thead {
      td, th {
        background-color: ${primaryBlue};
        color: #fff;
      }
    }
  }

  table.colored2 thead {
    td, th {
      background-color: ${purple};
    }
  }

  table.colored3 thead {
    td, th {
      background-color: ${orange};
    }
  }

  table.purpleLighten20 thead {
    td, th {
      background-color: ${purpleLighten20};
    }
  }

  table.purpleLighten80 thead {
    td, th {
      background-color: ${purpleLighten80};
    }
  }

  .ck-editor .ck-editor__editable_inline {
    min-height: 300px;
  }
  .ck-editor p {
    display: block;
  }
  .ck-editor__editable_inline {
    min-height: 400px;
  }
  .ck-editor .ck-content figure img {
    max-width: 600px;
  }
  :root {
    --ck-z-default: 10000 !important;
  }
  li[role=menuitem] {
    padding: 16px 12px;
  }

  /* Lower z-index for Zendesk chat widget to not sit on top of the Impact AI drawer */
  #launcher {
    z-index: 1000 !important;
  }
`;
